/* tslint:disable */
/* eslint-disable */
import { AbschnittDisplayModel as AceXFoundPortalCoreCaqModelsAbschnittDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/abschnitt-display-model';
import { LocalizedTextDisplayModel as AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/localized-text-display-model';
import { GlobalEnumsAceTypphase as AceXFoundPortalCoreEntitiesGlobalEnumsAceTypphase } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-typphase';
import { GlobalEnumsAceXfoundportalobjekt as AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-xfoundportalobjekt';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { AbschnittDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsAbschnittDisplayModelFormGroup } from '@/api/model-index';
import { LocalizedTextDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup } from '@/api/model-index';

export interface IPhaseDisplayModel {
  abschnitte?: null | Array<AceXFoundPortalCoreCaqModelsAbschnittDisplayModel>;
  absendenEinwilligungserklaerung?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  absendenUeberschrift?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  bestaetigunstextVorAbsenden?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  datenschutzerklaerungen?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  id?: null | string;
  name?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  portalObject?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
  reihenfolge?: null | number;
  typ?: AceXFoundPortalCoreEntitiesGlobalEnumsAceTypphase;
}
export class PhaseDisplayModel extends BaseModel implements IPhaseDisplayModel {
  abschnitte?: null | Array<AceXFoundPortalCoreCaqModelsAbschnittDisplayModel>;
  absendenEinwilligungserklaerung?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  absendenUeberschrift?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  bestaetigunstextVorAbsenden?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  datenschutzerklaerungen?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  id?: null | string;
  name?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  portalObject?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
  reihenfolge?: null | number;
  typ?: AceXFoundPortalCoreEntitiesGlobalEnumsAceTypphase;
}
class BasePhaseDisplayModelFormGroup extends FormGroup {
  private static _instance: PhaseDisplayModelFormGroup;
  
  public static get Instance(): PhaseDisplayModelFormGroup {
    this._instance = new PhaseDisplayModelFormGroup({
      abschnitte: new FormArray([]),
      absendenEinwilligungserklaerung: new FormArray([]),
      absendenUeberschrift: new FormArray([]),
      bestaetigunstextVorAbsenden: new FormArray([]),
      datenschutzerklaerungen: new FormArray([]),
      id: new FormControl(null),
      name: new FormArray([]),
      portalObject: new FormControl(null),
      reihenfolge: new FormControl(null),
      typ: new FormControl(null),
    });

    return this._instance;
  }
}


export class PhaseDisplayModelFormGroup extends BasePhaseDisplayModelFormGroup {
  public get Abschnitte(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsAbschnittDisplayModelFormGroup> {
    return this.controls["abschnitte"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsAbschnittDisplayModelFormGroup>;
  }
  public get AbsendenEinwilligungserklaerung(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["absendenEinwilligungserklaerung"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get AbsendenUeberschrift(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["absendenUeberschrift"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get BestaetigunstextVorAbsenden(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["bestaetigunstextVorAbsenden"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get Datenschutzerklaerungen(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["datenschutzerklaerungen"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get Id(): FormControl {
    return this.controls["id"] as FormControl;
  }
  public get Name(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["name"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get PortalObject(): FormControl {
    return this.controls["portalObject"] as FormControl;
  }
  public get Reihenfolge(): FormControl {
    return this.controls["reihenfolge"] as FormControl;
  }
  public get Typ(): FormControl {
    return this.controls["typ"] as FormControl;
  }
  

}

export module PhaseDisplayModelForm
  {
    export class FormFields
    {
      static _abschnitte: string = "abschnitte";
      static _absendenEinwilligungserklaerung: string = "absendenEinwilligungserklaerung";
      static _absendenUeberschrift: string = "absendenUeberschrift";
      static _bestaetigunstextVorAbsenden: string = "bestaetigunstextVorAbsenden";
      static _datenschutzerklaerungen: string = "datenschutzerklaerungen";
      static _id: string = "id";
      static _name: string = "name";
      static _portalObject: string = "portalObject";
      static _reihenfolge: string = "reihenfolge";
      static _typ: string = "typ";
    }
  }

